import { Card, ConfigProvider, Divider, Flex, List, Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import Icon from '@ant-design/icons';
import { ReactComponent as VehicleDetailsBlackSvg } from '../../../assets/vehicle-details-black.svg';
import { ReactComponent as VehicleDetailsSvg } from '../../../assets/vehicle-details-white.svg';
import { DARK, HYPHEN } from '../../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;
const VehicleDetails = ({ vehicleDetails }) => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          Divider: {
            margin: '6px',
            marginLG: '6px',
            colorSplit: theme === DARK ? '#383B3E' : '#979EA4',
          },
          Card: {
            colorBorderSecondary: theme === DARK ? '#2E3033' : '#E0E2E5',
            colorBgContainer: theme === DARK ? '#2E3033' : '#E0E2E5',
            boxShadowTertiary: 'none',
          },
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Card size="small" className="flex-grow-1" variant="borderless">
        <Flex vertical gap={8}>
          <Flex gap={6} align="center" className="title">
            <Icon
              component={
                theme === DARK ? VehicleDetailsSvg : VehicleDetailsBlackSvg
              }
              className="title-icon"
            />
            <Text strong className="title-text">
              Vehicle Details
            </Text>
          </Flex>
          <Text strong>
            {vehicleDetails?.brand || HYPHEN} {vehicleDetails?.model || HYPHEN}
            {' | '}
            {vehicleDetails?.fueltype || HYPHEN}
          </Text>
          <List
            dataSource={[
              {
                key: '1',
                label: 'Vehicle No.',
                value: vehicleDetails?.cab_registration || HYPHEN,
              },
              {
                key: '2',
                label: 'Vehicle Type',
                value: vehicleDetails?.vehilce_type || HYPHEN,
              },
              {
                key: '3',
                label: 'RB ID',
                value: vehicleDetails?.device_id || HYPHEN,
              },
              // {
              //   key: '4',
              //   label: 'RB kilometers',
              //   value: vehicleDetails?.rb_kilometers || HYPHEN,
              // },
              {
                key: '5',
                label: 'Total Trips Taken',
                value: vehicleDetails?.total_trips_taken || HYPHEN,
              },
            ]}
            renderItem={item => (
              <Flex vertical gap={6}>
                <Divider />
                <List.Item>
                  <Flex justify="space-between" gap={10} className="full-width">
                    <Text>{item?.label}</Text>
                    <Text strong>{item?.value}</Text>
                  </Flex>
                </List.Item>
              </Flex>
            )}
          />
        </Flex>
      </Card>
    </ConfigProvider>
  );
};

VehicleDetails.propTypes = {
  vehicleDetails: PropTypes.object,
};

export default VehicleDetails;
